const stickySideNav = {
	init: function(){
		this.stickySideNav();
	},

	stickySideNav: function() {
		var
			trigger = document.querySelector('#nav-sidebar-trigger'),
			aside = document.querySelector('#aside'),
			ph = document.querySelector('#aside-placeholder'),
			nav = document.querySelector('#nav-sticky'),
			links = document.querySelectorAll('.nav-sidebar-item'),
			fixedClassname = 'is-fixed',
			bottomClassname = 'hit-bottom',
			w, h,
			loc;

		function toggleNav() {
			nav.classList.toggle('is-visible');
		}

		function navWidth(ref, el) {
			w = ref.offsetWidth;
			h = nav.offsetHeight;

			if (loc <= 0) {
				el.style.width = w + 'px';
				ph.style.height = h + 'px';
			} else if (loc > 0) {
				el.style.width = '';
			}
		}

		function positionNav(el) {
			if (loc <= 0) {
				el.classList.add(fixedClassname);
				ph.classList.add('is-visible');
				navWidth(aside, nav);
			} else if (loc > 0) {
				el.classList.remove(fixedClassname);
				ph.classList.remove('is-visible');
				navWidth(aside, nav);
			}

			if ((loc + (aside.offsetHeight)) <  h) {
				el.classList.add(bottomClassname);
			} else {
				el.classList.remove(bottomClassname);
			}
		}

		function getLocation(el) {
			loc = el.getBoundingClientRect().y;
			positionNav(nav);
		}

		trigger.addEventListener('click', () => {
			toggleNav();
		});

		document.addEventListener('scroll', () => {
			getLocation(aside);
			positionNav(nav);
		});

		window.addEventListener('resize', () => {
			navWidth(aside, nav);
		});

		links.forEach(link => {
			link.addEventListener('click', () => {
				toggleNav();
			});
		});

		getLocation(aside);
		navWidth(aside, nav);
	}
};

export default stickySideNav;